/**
 * BETA — subscription module catalogue.
 */
import { nowIso } from "../uuid.js";
import { buildHistoriquePaiements } from "../data/modules.js";

export function register(route) {
  route("GET", "/modules", (ctx) => ({
    data: ctx.store.data.modules || [],
    historique: buildHistoriquePaiements(),
  }));

  route("POST", "/modules/acheter", (ctx) => {
    const code = ctx.body?.code_module || "MODULE";
    return {
      checkout_url: `https://demo.chargily.io/checkout/${code}-demo`,
      expires_at: nowIso(),
      message: "Paiement simulé — cliquez pour ouvrir Chargily (démo)",
    };
  });
}
